import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiConstants } from './constants/api-constants';
import { environment } from '../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AppConfigService {

	appConfig: any;

	constructor(private http: HttpClient) { }

	async loadAppConfig() {
		const configPath = `${environment.baseHref}assets/config/config.json`;
		return firstValueFrom(this.http.get(configPath))
			.then(data => {
				this.appConfig = data;
				const address = this.appConfig.API_SERVER || window.location.origin;
				ApiConstants.setData(address);
			});
	}

}
